export default __webpack_public_path__ + "static/media/demo2.656b3099.mp4";